import React from 'react'
import cx from 'classnames'

import InlineSvg from 'components/_new/ui/InlineSvg/InlineSvg'

import s from './Svg.scss'

import pom from './images/pom.svg'
import key from './images/key.svg'
import glad from './images/glad.svg'
import list from './images/list.svg'
import love from './images/love.svg'
import cart from './images/cart.svg'
import sleep from './images/sleep.svg'
import error from './images/error.svg'
import cards from './images/cards.svg'
import makeup from './images/makeup.svg'
import closed from './images/closed.svg'
import laptop from './images/laptop.svg'
import mirror from './images/mirror.svg'
import address from './images/address.svg'
import sadness from './images/sadness.svg'
import skipped from './images/skipped.svg'
import payment from './images/payment.svg'
import welcome from './images/welcome.svg'
import assembly from './images/assembly.svg'
import delivered from './images/delivered.svg'
import inProgress from './images/in-progress.svg'
import waitMinute from './images/wait-minute.svg'
import placeholder from './images/placeholder.svg'
import systemError from './images/system-error.svg'
import undelivered from './images/undelivered.svg'
import notification from './images/notification.svg'

import birdWithHeart from './images/bird-with-heart.svg'
import blackBird from './images/black-bird.svg'
import delivery from './images/delivery.svg'
import happyBird from './images/happy-bird.svg'
import noItems from './images/no-items.svg'
import notFound from './images/not-found.svg'
import sadBird from './images/sad-bird.svg'
import success from './images/success.svg'
import amazonPay from './images/amazonpay.svg'
import applePay from './images/applepay.svg'
import payPal from './images/paypal.svg'

import bottle from './images/bottle.svg'


export const trackingImages = {
  inProgress,
  noItems,
  payment,
  assembly,
  laptop,
  delivery,
  delivered,
} as const

export const paymentImages = {
  cards,
  cart,
  closed,
} as const

export const serviceImages = {
  address,
  list,
  pom,
} as const

export const emotionsImages = {
  happyBird,
  love,
  welcome,
  skipped,
  sadBird,
  birdWithHeart,
  undelivered,
} as const

export const nothingFoundImages = {
  notFound,
  error,
  systemError,
  placeholder,
  glad,
} as const

export const emptyStateImages = {
  sleep,
  success,
  mirror,
  sadness,
} as const

export const otherImages = {
  notification,
  key,
  makeup,
  waitMinute,
  blackBird,
} as const

export const logoImages = {
  amazonPay,
  applePay,
  payPal,
} as const

export const pictureImages = {
  bottle,
} as const

export const images = {
  ...trackingImages,
  ...paymentImages,
  ...serviceImages,
  ...emotionsImages,
  ...nothingFoundImages,
  ...emptyStateImages,
  ...otherImages,
  ...logoImages,
  ...pictureImages,
} as const

export const colors = [ 'brand-30', 'gray-30' ] as const
export type SvgName = keyof typeof images
export type SvgColor = typeof colors[number]

type SvgProps = {
  className?: string
  name: SvgName
  color?: SvgColor
}

const Svg: React.FunctionComponent<SvgProps> = ({ className, name, color = 'brand-30' }) => {
  if (!images[name]) {
    console.error(`There is no icon with name "${name}"`)
    return null
  }

  return (
    <InlineSvg
      className={cx(className, s[color])}
      src={images[name]}
      noWrapper
      cache
    />
  )
}


export default Svg
